module.exports = __webpack_public_path__ + "img/Hosting_Solutions-min.41f8e2a6.jpg";